"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorCode = void 0;
var ErrorCode;
(function (ErrorCode) {
    ErrorCode["AuthenticationFailed"] = "AuthenticationFailed";
    ErrorCode["ActiveSubscriptionAlreadyExists"] = "ActiveSubscriptionAlreadyExists";
    ErrorCode["AccountNotVerified"] = "AccountNotVerified";
    ErrorCode["ConfigurationError"] = "ConfigurationError";
    ErrorCode["Duplicated"] = "Duplicated";
    ErrorCode["ExpiredToken"] = "ExpiredToken";
    ErrorCode["IncorrectTransition"] = "IncorrectTransition";
    ErrorCode["InternalError"] = "InternalError";
    ErrorCode["InvalidUserDataResponse"] = "InvalidUserDataResponse";
    ErrorCode["InvalidPasswordFormat"] = "InvalidPasswordFormat";
    ErrorCode["InvalidConfirmation"] = "InvalidConfirmation";
    ErrorCode["InvalidEmailFormat"] = "InvalidEmailFormat";
    ErrorCode["InvalidEmailDomain"] = "InvalidEmailDomain";
    ErrorCode["InvalidPassword"] = "InvalidPassword";
    ErrorCode["InvalidAuthCode"] = "InvalidAuthCode";
    ErrorCode["InvalidActivationCode"] = "InvalidActivationCode";
    ErrorCode["InvalidTransactionToken"] = "InvalidTransactionToken";
    ErrorCode["MissingSubscription"] = "MissingSubscription";
    ErrorCode["NoSubscriptionAvailable"] = "NoSubscriptionAvailable";
    ErrorCode["InvalidRequest"] = "InvalidRequest";
    ErrorCode["InvalidToken"] = "InvalidToken";
    ErrorCode["LimitReached"] = "LimitReached";
    ErrorCode["MissingAuthorization"] = "MissingAuthorization";
    ErrorCode["MissingPermission"] = "MissingPermission";
    ErrorCode["NeedsRefresh"] = "NeedsRefresh";
    ErrorCode["NotFound"] = "NotFound";
    ErrorCode["Unavailable"] = "Unavailable";
    ErrorCode["InvalidMethodParams"] = "InvalidMethodParams";
    ErrorCode["UnableToDecode"] = "UnableToDecode";
    ErrorCode["AdobeErrorResponse"] = "AdobeErrorResponse";
    ErrorCode["XboxErrorResponse"] = "XboxErrorResponse";
    ErrorCode["TveErrorResponse"] = "TveErrorResponse";
    ErrorCode["IsisErrorResponse"] = "IsisErrorResponse";
    ErrorCode["Unknown"] = "Unknown";
    ErrorCode["CheckActivationCodeStatusChangeClientTimeOut"] = "CheckActivationCodeStatusChangeClientTimeOut";
    ErrorCode["UnsupportedProvider"] = "UnsupportedProvider";
    ErrorCode["DeviceLimitReached"] = "DeviceLimitReached";
    ErrorCode["PaymentDeclined"] = "PaymentDeclined";
    ErrorCode["InvalidCardDetails"] = "InvalidCardDetails";
    ErrorCode["MainProfileDeletion"] = "MainProfileDeletion";
    ErrorCode["CustomerNotFound"] = "CustomerNotFound";
    ErrorCode["ProfilesLimitReached"] = "ProfilesLimitReached";
    ErrorCode["StreamLimitReached"] = "StreamLimitReached";
    ErrorCode["CouponAlreadyUsed"] = "CouponAlreadyUsed";
    ErrorCode["InvalidCouponCode"] = "InvalidCouponCode";
    ErrorCode["InvalidPromoCode"] = "InvalidPromoCode";
    ErrorCode["CouponCodeNotFound"] = "CouponCodeNotFound";
    ErrorCode["BrandAndCountryNotSupported"] = "BrandAndCountryNotSupported";
    ErrorCode["NotSignedInWithMvpd"] = "NotSignedInWithMvpd";
    ErrorCode["PromoCodeAlreadyUsed"] = "PromoCodeAlreadyUsed";
    ErrorCode["InvalidProfileInput"] = "InvalidProfileInput";
    ErrorCode["PlanAlreadyChanged"] = "PlanAlreadyChanged";
    ErrorCode["ParentalPinNotSet"] = "ParentalPinNotSet";
    ErrorCode["ParentalPinAlreadySet"] = "ParentalPinAlreadySet";
    ErrorCode["InvalidParentalPinFormat"] = "InvalidParentalPinFormat";
    ErrorCode["InvalidParentalPin"] = "InvalidParentalPin";
    ErrorCode["SameParentalPinAlreadyUsed"] = "SameParentalPinAlreadyUsed";
    ErrorCode["ParentalPinLocked"] = "ParentalPinLocked";
    ErrorCode["AddingCouponNotAllowed"] = "AddingCouponNotAllowed";
    ErrorCode["SubscriptionExpired"] = "SubscriptionExpired";
    ErrorCode["SubscriptionAlreadyTied"] = "SubscriptionAlreadyTied";
    ErrorCode["UserAlreadyEntitled"] = "UserAlreadyEntitled";
})(ErrorCode = exports.ErrorCode || (exports.ErrorCode = {}));
